// Thin BroadcastChannel wrapper: same-origin pub/sub across windows/tabs.
// A channel never receives its own publish() — only other instances do.
export function createCrossWindowChannel<T>(channelName: string) {
  const channel = new BroadcastChannel(channelName);

  return {
    publish(message: T): void {
      channel.postMessage(message);
    },
    subscribe(handler: (message: T) => void): () => void {
      const listener = (event: MessageEvent<T>) => handler(event.data);
      channel.addEventListener('message', listener);
      return () => channel.removeEventListener('message', listener);
    },
  };
}
